import React from "react";
import "./Spinner.css";

const Spinner = ({ size = 200 }) => {
  return (
    <React.Fragment>
      <div class="spinner"></div>
    </React.Fragment>
  );
};

export default Spinner;
